import { formatNumber } from "accounting"
import { Progress } from "antd"

export const baseColumns = [
  {
    title: "Users",
    dataIndex: "count",
    key: "count",
    width: "10px",
    align: "right",
    render: (value, record) => (
      <>
        {formatNumber(value)}
        <Progress
          percent={record?.count || 0}
          showInfo={false}
          strokeColor={"#225AEA"}
          trailColor={"transparent"}
          size={["100%", "2px"]}
          style={{
            position: "absolute",
            width: "100%",
            left: 0,
            bottom: 0,
            padding: 0,
            margin: 0,
            fontSize: "2px"
          }}
        />
      </>
    )
  }
]

export const columnsSource = [
  {
    title: "Source",
    dataIndex: "label",
    width: "10px",
    key: "label",
    render: (value) => (value && value !== "Null" ? value : "N/A")
  },
  ...baseColumns
]

export const columnsCampaign = [
  {
    title: "Campaign",
    dataIndex: "label",
    width: "10px",
    key: "label",
    render: (value) => (value && value !== "Null" ? value : "N/A")
  },
  ...baseColumns
]
